<template>
  <div class="bbp-accordion-content-add">
    <div
      v-if="!isEditMode"
      :class="[
        'bbp-accordion-content-add-new',
        isAdd && 'bbp-accordion-content-add-new_active'
      ]"
      @click="onAddComment"
    >
      <div v-html="plusIcon()" />
      Add new comment
    </div>
    <div
      class="bbp-accordion-content-add__wrap"
      :class="[!isAdd && 'bbp-accordion-content-add__wrap_hide']"
      :style="{height: heightInputNew}"
      :key="isAdd"
    >
      <div
        v-if="!isEditMode"
        class="bbp-accordion-content-add__container"
      >
        <div class="bbp-accordion-content-add__label">
          New comment
        </div>
        <BBPAccordionContentCellButtons
          @onSave="onClose"
          @onClose="onResetDefault"
        />
      </div>

      <BBPTextareaEditor
        :input="input"
        :model="model"
        :project="model"
        @input="inputHandler"
      />
    </div>
  </div>
</template>

<script>
import { PLUS_ICON } from '@/constants/icons'
import { LOCALHOST_DOMAIN_ID } from '@/constants/domainListPlatform'
import removeUserNameOnComment from '@/mixin/removeUserNameOnComment'
import BBPTextareaEditor from '@/components/Main/BBPForm/BBPTextareaEditor/BBPTextareaEditor'
import BBPAccordionContentCellButtons from '@/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellButtons'
import RequestApi from '@/api/Requests/api'
import TimerApi from '@/api/Timer/api'

export default {
  name: 'BBPAccordionContentCellAdd',
  components: {
    BBPTextareaEditor,
    BBPAccordionContentCellButtons
  },
  props: {
    heightContent: {
      type: String,
      default: ''
    },
    offsetHeight: {
      type: Number,
      default: 0
    },
    row: {
      type: Object,
      default: () => ({})
    },
    currentItem: {
      type: Object,
      default: () => ({})
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isSave: {
      type: Boolean,
      default: false
    },
    isItemsLength: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: () => ([])
    }
  },
  mixins: [removeUserNameOnComment],
  data: () => ({
    plusIcon: PLUS_ICON,
    isAdd: false,
    input: {
      model: 'commentText',
      options: [],
      isAddUser: true,
      inputStyle: {
        height: '0px',
        minHeight: 90,
        whiteSpace: 'pre-wrap'
      }
    },
    model: {
      commentText: '',
      commentUsers: []
    },
    heightInputNew: 0,
    newItemHeight: 0
  }),
  computed: {
    heightParent: {
      get () {
        return this.heightContent
      },
      set (data) {
        this.$emit('update:heightContent', data)
      }
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    currentDomain () {
      return this.$store.getters.currentDomain
    }
  },
  methods: {
    inputHandler (item) {
      this.model.commentText = item
    },
    onAddComment () {
      this.isAdd = true
      this.createHeight()
    },
    createHeight () {
      const { inputStyle = {} } = this.input
      const { minHeight } = inputStyle
      inputStyle.height = `${this.isAdd ? minHeight : 0}px`
      const padding = this.isEditMode ? 14 : 32
      const newHeight = this.isAdd ? minHeight + padding : 0
      this.heightInputNew = `${this.isAdd ? newHeight : 0}px`
      this.heightParent = `${this.offsetHeight + newHeight + this.newItemHeight}px`
      this.$emit('update:offsetHeight', this.offsetHeight + this.newItemHeight)
    },
    createDefault () {
      const { comment, totalTime } = this.currentItem
      this.model.commentText = comment
      this.$emit('update:currentTime', totalTime)
    },
    onClose () {
      if (!this.isAdd) return
      this.isAdd = false
      const { totalTime, comment } = this.currentItem
      const { commentText } = this.model
      if (this.currentTime !== totalTime && this.isEditMode) this.updateSubTimer()
      if (comment !== commentText) this.createComment()
      this.model = {
        commentText: '',
        commentUsers: []
      }
      this.newItemHeight = 0
      this.$emit('update:isEdit', '')
    },
    createBody () {
      const { commentText, commentUsers = [] } = this.model
      const { _id } = this.row
      return {
        comment: {
          text: this.removeUserNameOnComment(commentText, commentUsers),
          users: commentUsers.length ? commentUsers.map((el) => el._id) : []
        },
        requestId: this.isEditMode ? _id : undefined,
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        date: new Date(),
        domain: this.currentDomain ? this.currentDomain.id : LOCALHOST_DOMAIN_ID
      }
    },
    async createComment () {
      const { commentText } = this.model
      if (commentText) this.createElement(commentText)
      this.createHeight()
      const { _id } = this.currentItem
      if (!commentText) return
      const body = this.createBody()
      const name = this.isEditMode ? 'editCommentRequest' : 'createCommentRequest'
      const id = this.isEditMode ? _id : this.row.id
      try {
        const { data } = await RequestApi[name](body, id)
        if (this.isEditMode) {
          const { subtimers = [] } = this.currentItem
          data.subtimers = subtimers
          const index = this.row.comments.findIndex((el) => el._id === _id)
          this.row.comments.splice(index, 1, data)
        } else {
          this.row.comments.unshift(data)
        }
      } catch (err) {
        console.error(err)
      }
    },
    async updateSubTimer () {
      const { subtimers = [], totalTime } = this.currentItem
      const [ item = {} ] = subtimers
      const { _id } = item
      try {
        await TimerApi.updateSubTimer({totalTime: this.currentTime}, _id)
        this.currentItem.totalTime = this.currentTime
        const { totalTime: totalTimeRow } = this.row
        this.row.totalTime = totalTimeRow - totalTime + this.currentTime
      } catch (err) {
        console.error(err)
      }
    },
    createElement (commentText) {
      const parent = document.querySelector('.bbp-accordion-content__wrap')
      const { width, height: heightParent } = parent.getBoundingClientRect()
      const div = document.createElement('div')
      const widthCommentBlock = width - 282
      div.innerHTML = commentText
      div.style.width = `${widthCommentBlock}px`
      div.style.whiteSpace = 'pre-wrap'
      parent.append(div)
      const { height } = div.getBoundingClientRect()
      this.heightParent = `${heightParent}px`
      setTimeout(() => div.remove(), 0)
      if (this.isEditMode) {
        const element = document.getElementById(`bbp-accordion-content-item__comment_${this.currentItem._id}`)
        const { height: heightElem } = element.getBoundingClientRect()
        this.newItemHeight = height - heightElem
      } else {
        this.newItemHeight = height + 25
      }
    },
    onResetDefault () {
      this.isAdd = false
      this.model = {
        commentText: '',
        commentUsers: []
      }
      this.newItemHeight = 0
      this.$emit('update:isEdit', '')
      this.createHeight()
    }
  },
  watch: {
    isCancel () {
      const { comment } = this.currentItem
      this.isAdd = false
      this.model = {
        commentText: comment,
        commentUsers: []
      }
      this.newItemHeight = 0
      this.$emit('update:isEdit', '')
      this.createElement(comment)
      this.createHeight()
    },
    isSave () {
      this.onClose()
    },
    isItemsLength () {
      const [first] = this.items
      const { comment } = first
      this.createElement(comment)
      this.createHeight()
    }
  },
  beforeMount () {
    this.input.options = this.usersListProjects
    if (this.isEditMode) {
      this.onAddComment()
      this.createDefault()
    }
  },
  mounted () {
    if (this.isEditMode) {
      this.createElement()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-accordion-content-add {

    &__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__wrap {
      transition: 0.3s;

      &_hide {
        opacity: 0;
        z-index: -1;
      }
    }

    &__label {
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      color: $color-denim;
      margin: 0 0 4px 0;
    }
  }

  .bbp-accordion-content-add-new {
    display: grid;
    grid-template-columns: 10px max-content;
    grid-gap: 0 4px;
    color: $color-denim;
    cursor: pointer;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
    margin: 0 0 12px 0;

    &_active {
      transition: 0.15s;
      color: $color-silver;
    }
  }
</style>

<style lang="scss">
@import "../../../../sass/variables";

  .bbp-accordion-content-add-new_active {
    svg path {
      fill: $color-silver;
    }
  }

  .bbp-accordion-content-add {
    .bbp-input {
      font-size: 12px;
      line-height: 16px;
      color: $color-black;
      background: $color-white;
      transition: 0.3s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPAccordionCell/BBPAccordionContentCellAdd.vue